var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"Store"}},[(_vm.resuouce)?_c('iframe',{attrs:{"id":"iframe","src":_vm.resuouce}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }